<template>
  <div class="modal-habit habit-failed">
    <ul v-if="response">
      <li
        v-for="(state, day) in response.history"
        :key="day"
        :class="{ 'habit-done': state === true, 'habit-fail': state === false }"
      >
        <figure>
          <!-- TODO extract svg -->
          <svg
            v-if="state !== null"
            width="34px"
            height="34px"
            viewBox="0 0 34 34"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="1_zero" transform="translate(-120.000000, -284.000000)" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="Ukoly/Cíl-Ano-Ne" transform="translate(16.000000, 228.000000)">
                        <g id="Group-Copy-2" transform="translate(104.000000, 56.000000)">
                            <path d="M17,34 C7.61115925,34 0,26.3888407 0,17 C0,7.61115925 7.61115925,0 17,0 C26.3888407,0 34,7.61115925 34,17 C34,26.3888407 26.3888407,34 17,34 Z M25,11.1169231 L22.8830769,9 L17,14.8830769 L11.1169231,9 L9,11.1169231 L14.8830769,17 L9,22.8830769 L11.1169231,25 L17,19.1169231 L22.8830769,25 L25,22.8830769 L19.1169231,17 L25,11.1169231 Z" id="zvyk-bily-nesplneno"></path>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </figure>
        <abbr :title="getFullNameDay(day)">{{ getShortNameDay(day) }}</abbr>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      keys: ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']
    }
  },
  methods: {
    getShortNameDay(day) {
      const days = this.keys.indexOf(day)
      const date = moment()
        .startOf('week')
        .add(days, 'days')

      return date.format('dd')
    },
    getFullNameDay(day) {
      const days = this.keys.indexOf(day)
      const date = moment()
        .startOf('week')
        .add(days, 'days')

      return date.format('dddd')
    }
  }
}
</script>
